// Columna izquierda de Tiendas: búsqueda, tipo y rango de NPI M30, como el mock.
// Tipo y NPI van deshabilitados con su porqué: sin fuente confiable cualquier filtro vaciaría la lista.
import { FiltersColumn } from '@/shared/patterns/FiltersColumn';
import { Input } from '@/kit';
import {
    countActiveStoreFilters,
    EMPTY_STORES_FILTERS,
    type StoresFilters,
} from '../lib/storesTable';

const LABEL = 'mb-[5px] text-[9.5px] font-bold uppercase tracking-[0.08em] text-muted-foreground';
const GROUP = 'mt-2.5';
const FIELD = 'h-[26px] text-[11.5px]';
const CHIP =
    'cursor-not-allowed whitespace-nowrap rounded-full border border-border bg-card px-2 py-0.5 text-[9.5px] font-semibold opacity-50';

const KIND_TITLE = 'El tipo de tienda (propia o subdistribuidor) todavía no tiene fuente confiable';
const NPI_TITLE = 'El NPI M30 por tienda todavía no tiene fuente';

export function StoresFiltersPanel({
    filters,
    onChange,
    collapsed,
    onToggleCollapsed,
}: {
    filters: StoresFilters;
    onChange: (next: StoresFilters) => void;
    collapsed: boolean;
    onToggleCollapsed: () => void;
}) {
    return (
        <FiltersColumn
            collapsed={collapsed}
            onToggleCollapsed={onToggleCollapsed}
            activeCount={countActiveStoreFilters(filters)}
            onReset={() => {
                onChange({ ...EMPTY_STORES_FILTERS, pill: filters.pill });
            }}
        >
            <div className={GROUP}>
                <div className={LABEL}>Búsqueda</div>
                <Input
                    type="search"
                    value={filters.query}
                    onChange={(e) => {
                        onChange({ ...filters, query: e.target.value });
                    }}
                    placeholder="Nombre, clave, zona"
                    aria-label="Buscar tienda"
                    className={FIELD}
                />
            </div>

            <div className={GROUP}>
                <div className={LABEL}>Tipo</div>
                <div className="flex flex-wrap gap-[3px]" title={KIND_TITLE}>
                    <button type="button" disabled aria-pressed={false} className={CHIP}>
                        Propia
                    </button>
                    <button type="button" disabled aria-pressed={false} className={CHIP}>
                        Subdistribuidor
                    </button>
                </div>
            </div>

            <div className={GROUP}>
                <div className={LABEL}>NPI M30 (%)</div>
                <div className="flex items-center gap-1.5" title={NPI_TITLE}>
                    <Input
                        type="number"
                        disabled
                        placeholder="mín"
                        aria-label="NPI M30 mínimo"
                        className={FIELD}
                    />
                    <span className="text-muted-foreground">—</span>
                    <Input
                        type="number"
                        disabled
                        placeholder="máx"
                        aria-label="NPI M30 máximo"
                        className={FIELD}
                    />
                </div>
            </div>
        </FiltersColumn>
    );
}
